//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003a0tn on 13.07.2016.
 */
(function () {
    'use strict';

    angular
        .module('container.core')
        .factory('utilService', utilService)
    ;

    function utilService() {
        var service = {
            generateUuid: generateUuid,
            isValidGuid: isValidGuid,
            setEmptyIfNull: setEmptyIfNull,
            bytesToSize: bytesToSize
        };
        return service;

        function generateUuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                return v.toString(16);
            });
        }

        function isValidGuid(value) {
            const regexExp = /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/gi;
            return regexExp.test(value);
        }

        
        function setEmptyIfNull(value) {
            if (value === undefined || value === null || value === "null") {
                return "";
            }
            else {
                return _.escape(value);
            }
        }

        /**
         * Convert number of bytes into human readable format   
         *
         * @param integer bytes     Number of bytes to convert     
         * @return string
         */
        function bytesToSize(bytes) {
            if (bytes === undefined || bytes === null) return "";
            if (bytes === 1) return "1 Byte";
            if (bytes === 0) return "0";
            var bytesFl = parseFloat(bytes);
            var k = 1024.00;
            var dm = 1;
            var posttxt = 0;
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            var precisions = [0, 0, 1, 2, 3];
            while (bytesFl >= k) {
                posttxt++;
                bytesFl = bytesFl / k;
            }
            return parseFloat(bytesFl).toFixed(precisions[posttxt]) + " " + sizes[posttxt];
        }

    }

})();